import React from "react";

import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { SaleStatusModal } from "components/SaleStatus/Modal";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";

import { useModalAdapter } from "hooks";
import { ApiModel } from "constants/loading";

interface ParamsReturns {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Form default values from URL params
  formDefaults: any;
}

export function SaleStatusModalAdapter(
  props: ModalAdapterProps,
): React.JSX.Element {
  const [hashParams, ignored, onClose] = useModalAdapter<ParamsReturns>(
    ModalTypes.SaleStatus,
    props,
  );

  const { id, ...formDefaults } = hashParams;

  return (
    <WaitForSync requiredData={[ApiModel.SALE_STATUSES]}>
      <SaleStatusModal id={id} formDefaults={formDefaults} onClose={onClose} />
    </WaitForSync>
  );
}
